import * as React from 'react';
import Descriptions from 'antd/lib/descriptions';
import Divider from 'antd/lib/divider';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import { displayNameForIntegrationType, iconAndAltForIntegrationType } from '@/helpers/integrationHelpers';
import { BranchConfig, FeatureAffiliationConfig, TagConfig } from '@/types';
import { antGrey } from '../styles/globalStyles';

export const BranchConfigPreview: React.FC<{ branchConfig: BranchConfig }> = ({ branchConfig }) => {
    const nonHotfixBranchPatterns =
        branchConfig.releaseBranchPatterns?.filter((branchPattern, index) => !branchPattern.isHotfix && index === 0) ??
        [];
    const hotfixBranchPatterns =
        branchConfig.releaseBranchPatterns?.filter((branchPattern, index) => branchPattern.isHotfix && index === 0) ??
        [];

    return (
        <Descriptions bordered column={1}>
            <Descriptions.Item label="Release branch">
                <Space
                    direction="vertical"
                    split={<Divider type="horizontal" style={{ backgroundColor: antGrey.grey5, width: '100%' }} />}
                >
                    {nonHotfixBranchPatterns.length > 0 && (
                        <Space split={<Divider type="vertical" />}>
                            {nonHotfixBranchPatterns.map((branchPattern) => (
                                <Text code key={branchPattern.pattern}>
                                    {branchPattern.pattern}
                                </Text>
                            ))}
                        </Space>
                    )}
                    {hotfixBranchPatterns.length > 0 && (
                        <Space split={<Divider type="vertical" />}>
                            <Text>Hotfix</Text>
                            {hotfixBranchPatterns.map((branchPattern) => (
                                <Text code key={branchPattern.pattern}>
                                    {branchPattern.pattern}
                                </Text>
                            ))}
                        </Space>
                    )}
                </Space>
            </Descriptions.Item>

            {branchConfig.workingBranch && (
                <Descriptions.Item label="Working branch">
                    <Text>{branchConfig.workingBranch}</Text>
                </Descriptions.Item>
            )}
        </Descriptions>
    );
};

export const TagConfigPreview: React.FC<{ tagConfig: TagConfig }> = ({ tagConfig }) => (
    <Descriptions bordered column={1}>
        <Descriptions.Item label="Release tag pattern">
            <Space>
                <Text code>{tagConfig.pattern}</Text>
            </Space>
        </Descriptions.Item>
    </Descriptions>
);

export const FeatureAffiliationConfigPreview: React.FC<{ featureAffiliationConfig: FeatureAffiliationConfig }> = ({
    featureAffiliationConfig,
}) => {
    const [icon, alt] = iconAndAltForIntegrationType(featureAffiliationConfig.integrationId);
    return (
        <Descriptions bordered column={1}>
            <Descriptions.Item
                label={
                    <Space split={<Divider type="vertical" />}>
                        <Text>{featureAffiliationConfig.type}</Text>
                        <Text code>{featureAffiliationConfig.pattern}</Text>
                    </Space>
                }
            >
                <img src={icon} alt={alt} width={20} height={20} />
                <Text>{displayNameForIntegrationType(featureAffiliationConfig.integrationId)}</Text>
            </Descriptions.Item>
        </Descriptions>
    );
};
